﻿// Форматирование телефона для RU c фиксированным шаблоном +7 (XXX) XXX-XX-XX
class PhoneFormatter {
    constructor() {
        this.init();
    }

    init() {
        this.phoneInputs = document.querySelectorAll('input.phone-formatted');

        this.phoneInputs.forEach((input) => {
            this.setupPhoneInput(input);
        });
    }

    setupPhoneInput(input) {
        // Нормализуем предзаполненное значение из БД в единый формат.
        input.value = this.simpleFormatValue(input.value);

        input.addEventListener('input', (e) => {
            this.applyMask(e.target);
        });

        input.addEventListener('paste', (e) => {
            this.handlePaste(e);
        });

        input.addEventListener('blur', (e) => {
            this.formatOnBlur(e.target);
        });
    }

    applyMask(input) {
        this.simpleFormat(input);
    }

    handlePaste(e) {
        e.preventDefault();
        const pastedData = e.clipboardData.getData('text');
        const input = e.target;

        input.value = this.simpleFormatValue(pastedData);
    }

    formatOnBlur(input) {
        input.value = this.simpleFormatValue(input.value);
    }

    simpleFormat(input) {
        input.value = this.simpleFormatValue(input.value);
    }

    simpleFormatValue(value) {
        const cleanDigits = this.normalizeRuDigits(value);

        if (!cleanDigits) return '';

        let result = '+7';

        if (cleanDigits.length > 1) {
            result += ' (' + cleanDigits.slice(1, 4);
        }
        if (cleanDigits.length >= 4) {
            result += ')';
        }

        if (cleanDigits.length >= 5) {
            result += ' ' + cleanDigits.slice(4, 7);
        }

        if (cleanDigits.length >= 8) {
            result += '-' + cleanDigits.slice(7, 9);
        }

        if (cleanDigits.length >= 10) {
            result += '-' + cleanDigits.slice(9, 11);
        }

        return result;
    }

    normalizeRuDigits(value) {
        const digits = String(value || '').replace(/\D/g, '');
        if (!digits) return '';

        // Требование:
        // - если первая цифра 8 или 7 -> начинаем с +7;
        // - если первая другая -> добавляем +7 перед введенной цифрой и сохраняем ее.
        if (digits[0] === '8') {
            return ('7' + digits.slice(1)).slice(0, 11);
        }

        if (digits[0] === '7') {
            return digits.slice(0, 11);
        }

        return ('7' + digits).slice(0, 11);
    }
}

// Инициализация при загрузке страницы
if (typeof document !== 'undefined') {
    document.addEventListener('DOMContentLoaded', () => {
        if (!window.phoneFormatterInitialized) {
            new PhoneFormatter();
            window.phoneFormatterInitialized = true;
        }
    });
}

if (typeof module !== 'undefined' && module.exports) {
    module.exports = PhoneFormatter;
}
